import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { environment } from '../../../../../environments/environment';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
@Component({
    selector: 'app-lob-bulk-edit',
    templateUrl: './lob-bulk-edit.component.html',
    styleUrls: ['./lob-bulk-edit.component.css'],
    standalone: false
})
export class LobBulkEditComponent {
  disableSubmit = false;
  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  Filepath = environment.lobMaintenanceBulkEditTemplate;
  fileToUpload: File = null;
  showLoader: boolean = false;
  @Output() bulkSuccessEvent : EventEmitter<any> = new EventEmitter();

  constructor(private maintenanceService: MaintenanceService, 
  private toastr: ToastrService,private sharedAuthService: SharedAuthService) { }

  uploadFileEvt(files: FileList) {
    if (files && files.length) {
      this.fileToUpload = files.item(0);
    } else {
      this.fileToUpload = null;
    }
  }

  submit() {
    const fileType = this.fileToUpload.type;
    const fileExtension = this.fileToUpload.name.split('.').pop();
    if (!fileType ||
      !["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"].includes(fileType)
      || !['xls', 'xlsx', 'xlsm', 'xlsb'].includes(fileExtension)
    ) {
      this.toastr.error("File format is not supported, Please try with excel files only.");
      return false;
    }
    const formData: FormData = new FormData();
    formData.append('lob_file', this.fileToUpload, this.fileToUpload.name);
    formData.append('User_msid', this.sharedAuthService.getMsid());
    formData.append('User_email', sessionStorage.getItem('loggedInUserEmail'));
    this.showLoader = true;
    this.maintenanceService.lobBulkUpload(formData).subscribe(res => {
        if(res) {
          this.showLoader = false;
          this.fileToUpload = null;
          this.fileInput.nativeElement.value = '';
          this.toastr.success("Thank you for submitting the request. You will be notified via email on status", '', { positionClass: 'toast-top-center', timeOut: 2000, })
          this.bulkSuccessEvent.emit();
        }
    }, (error) => {
      console.error(error);
      this.showLoader = false;
      this.toastr.error("Something went wrong, Please try again later.", '', { positionClass: 'toast-top-center', timeOut: 1000, })
    });
  }

}
